// 导航（移动端）
<template>
  <div class="cmain">
    <div class="close">
      <span class="closeImg" @click="prev"></span>
    </div>
    <div class="outList" @click="index">首页</div>
    <el-container class="more">
      <el-aside width="100%" style="background-color: rgb(238, 241, 246)">
        <el-menu :default-openeds="['0']">
          <el-submenu index="1">
            <template slot="title">业务介绍</template>
            <el-menu-item index="1-1" @click="project">工程项目质量全面提升过程咨询</el-menu-item>
            <el-menu-item index="1-2" @click="train">专项培训</el-menu-item>
            <el-menu-item index="1-3" @click="information">项目信息化建设</el-menu-item>
            <el-menu-item index="1-4" @click="law">法律服务咨询</el-menu-item>
            <el-menu-item index="1-5" @click="double">双重预防体系咨询服务</el-menu-item>
            <el-menu-item index="1-6" @click="items">项目汇报视频PPT材料服务</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
    </el-container>
    <div class="outList" @click="news">新闻中心</div>
    <div class="outList" @click="mAboutour">关于我们</div>
    <div class="outList" @click="mContact">联系我们</div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      show: false,
      addimg: true,
      jianimg: false,
    };
  },
  methods: {
    moree() {
      this.show = !this.show;
      this.addimg = !this.addimg;
      this.jianimg = !this.jianimg;
    },
    prev() {
      //   this.$router.go('-1');
      this.$router.replace("/mIndex");
    },
    index() {
      this.$router.replace("/mIndex");
    },
    project() {
      this.$router.replace("/mProject");
    },
    train() {
      this.$router.replace("/mTrain");
    },
    information() {
      this.$router.replace("/mInformation");
    },
    law() {
      this.$router.replace("/mLaw");
    },
    double() {
      this.$router.replace("/mDouble");
    },
    items() {
      this.$router.replace("/mItems");
    },
    mAboutour(){
      this.$router.replace("/mAboutour");
    },
    news(){
      this.$router.replace("/mNews");
    },
    mContact(){
      this.$router.replace("/mContact");
    }
  },
  components: {},
};
</script>

<style scoped lang="less">
.cmain {
  margin-top: 0;
  .close {
    width: 100%;
    height: 2.5rem;
    .closeImg {
      display: block;
      width: 1rem;
      height: 1rem;
      background: url("../../assets/img/mobile/micon/close.png") 0 0 no-repeat;
      background-size: 100%;
      float: right;
      margin-top: 0.8rem;
      margin-right: 1.3rem;
    }
  }
  .outList {
    width: 100%;
    height: 3.4rem;
    line-height: 3.4rem;
    padding-left: 1rem;
    border-top: 0.02rem solid #bfbfbf;
    box-sizing: border-box;
    font-size: 0.75rem;
  }
  .list {
    width: 100%;
    height: 1.2rem;
    margin: 0;
    padding: 0;
  }
  .more {
    font-size: 0.75rem !important;
    color: rgb(191, 191, 191) !important;
    // border-top: 0.03rem solid #bfbfbf !important;
    box-sizing: border-box !important;
  }
}

</style>
